import {Component, OnInit} from '@angular/core';
import {StepComponent} from '../../step/step.component';
import {StepService} from '../../services/step.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ElementService} from '../../services/element.service';
import {PortalService} from '../../services/portal.service';
import {StancheckAnfrage} from "../anfrage/stancheck.anfrage";
import {StancheckRequestService} from "../services/request.service";

/**
 * Special component for the start page of the chapter "eingabe". Only Textoutputs, no form.
 */
@Component({
    selector: 'app-stancheck-gebaeude-start',
    templateUrl: './gebaeude.start.component.html',
    standalone: false
})
export class GebaeudeStartComponent extends StepComponent implements OnInit {

  /**
   * current user data
   */
  anfrage: StancheckAnfrage;
  /**
   * current portalId
   */
  portalId: string;

  /**
   * placeholder for portalname in welcome text
   */
  welcomePlaceholder: any = {};

  constructor(protected stepService: StepService, protected router: Router,
              protected requestService: StancheckRequestService, protected elementService: ElementService,
              protected portalService: PortalService) {
    super(stepService, router, elementService);
  }
  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();
    // get the current portalId
    // this.portalId = this.portalService.currentPortalId;
    //
    // this.anfrage = this.requestService.getAnfrage();
    //
    // // init Placeholder
    // if(this.portalService.getConfig('embed.portal.welcometext')) {
    //   this.welcomePlaceholder = {
    //     portalPlaceholder: ' ' + this.portalService.getConfig('embed.portal.welcometext')
    //   };
    // }
    // else {
    //   this.welcomePlaceholder = {
    //     portalPlaceholder: ''
    //   };
    // }
  }

}
